import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";

const Specialities = ({ search }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [specialities, setSpecialities] = useState([]);
  const [filtered, setFiltered] = useState([]);

  useEffect(() => {
    const fetchSpecialities = async () => {
      try {
        const res = await api.get("/api/specialties-descriptions");

        const formatted = res.data
          .filter(item => item.description_section)
          .map(item => ({
            name: item.name,
            slug: item.slug,
            img: item.description_section.icon,
            title: item.description_section.title || item.name,
            subtitle: item.description_section.description || ""
          }));

        setSpecialities(formatted);
        setFiltered(formatted);
      } catch (error) {
        console.error("Failed to fetch specialities", error);
      } finally {
        setTimeout(() => setLoading(false), 800);
      }
    };

    fetchSpecialities();
  }, []);

  useEffect(() => {
    const result = specialities.filter(item =>
      item.title.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(result);
  }, [search, specialities]);

  return (
    <section className="specialities-section-list">
      <div className="container">
        <div className="row justify-content-center">
          {loading ? (
            [1, 2, 3, 4].map((_, i) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={i}>
                <div className="speciality-card skeleton">
                  <div className="skeleton-img shimmer"></div>
                  <div className="skeleton-line long shimmer mt-3"></div>
                  <div className="skeleton-line medium shimmer"></div>
                </div>
              </div>
            ))
          ) : filtered.length === 0 ? (
            <p className="no-results">No specialities found.</p>
          ) : (
            filtered.map((item, i) => (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={i} onClick={() => navigate(`/specialties/${item.slug}`)} style={{ cursor: "pointer" }}>
                <div className="speciality-card">
                  <div className="speciality-img-wrapper">
                    <img src={`${process.env.REACT_APP_WEB_URL}${item.img}`} alt={item.title} />
                  </div>
                  <h3 className="speciality-title">{item.title}</h3>
                  <p className="speciality-subtitle">{item.subtitle}</p>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Specialities;
